import axios, { AxiosError, AxiosResponse } from 'axios';

export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    responseType: 'json',
});